import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Toggle } from '@fluentui/react';
import { getGenericModal } from '../../../redux/selectors/ui';
import { ModalDocumentAction } from '../../../redux/actions/modal';
import { withTranslation, WithTranslation  } from 'react-i18next';

interface DownloadExcelReportStateProps {
    form?: {
        showAllversions?: boolean,
    }
}

interface DownloadExcelReportDispatchProps {
    setContextItemProperty: typeof ModalDocumentAction.setContextItemProperty
}

type DownloadExcelReportProps = DownloadExcelReportStateProps & DownloadExcelReportDispatchProps & RouteComponentProps & WithTranslation;

class DownloadExcelReport extends React.Component<DownloadExcelReportProps> {
    render(){
        const { form, setContextItemProperty, t } = this.props;

        return (
            <Toggle
                label={t('Download the complete index history (all revisions) of the documents')}
                checked={!!(form && form.showAllversions)}
                onText={t('Yes')}
                offText={t('No')}
                onChange={(e, checked) => {
                    setContextItemProperty({id: 'excelReport', name: 'showAllversions', value: !!checked});
                }}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    form: (state) => (getGenericModal('excelReport')(state)) ? (getGenericModal('excelReport')(state) as any).contextItem : undefined,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setContextItemProperty: ModalDocumentAction.setContextItemProperty
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(DownloadExcelReport)));